import { render, staticRenderFns } from "./ProfessionalTeamPage.vue?vue&type=template&id=19deb0b0&scoped=true"
import script from "./ProfessionalTeamPage.vue?vue&type=script&lang=js"
export * from "./ProfessionalTeamPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19deb0b0",
  null
  
)

export default component.exports